import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const SliderContainer = styled.div`
  width: 224px;
`

export const InputContainer = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--border-secondary);
  padding: var(--space-125);
`

export const InputStyles = styled.input`
  border: none;
  outline: none;
  width: 32px;
  text-align: right;
  font-size: var(--font-size-300);

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  [type='number'] {
    -moz-appearance: textfield;
  }
`

export const Postfix = styled.div`
  font-size: var(--font-size-300);
  color: var(--text-primary);
`
